import config from '@feature-config/core/sample-data/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { SampleDataFeature } from './SampleDataFeature';

const sampleDataFeature: FeatureModule = createFeatureModule(
  config,
  SampleDataFeature,
  'core/sample-data'
);

export default sampleDataFeature;
